import { api } from './client'
import type { components } from './generated/schema'

export type WarehousePositionLotType = 'product' | 'packaging'

/** Tồn khả dụng của một mặt hàng (sản phẩm hoặc vật tư) đang đứng ở một vị trí,
 *  đã gộp mọi lô active còn hàng ở đó. Server đã sắp: sản phẩm trước vật tư,
 *  mỗi nhóm theo tên tiếng Việt — tầng hiển thị giữ nguyên thứ tự. */
export type WarehousePositionStockItem =
    components['schemas']['WarehousePositionStockItem']

export interface WarehousePosition {
    id: string
    code: string
    name?: string | null
    applicable_lot_types: WarehousePositionLotType[]
    is_active: boolean
    /** Kệ hàng hoàn duy nhất: lô hoàn về đã hết tồn được chuyển sang đây. */
    is_return_shelf: boolean
    /** Kệ bán máy POS: gợi ý lô của quầy ưu tiên lô ở đây. Nhiều kệ được phép. */
    is_pos_shelf: boolean
    /** Kệ hàng lỗi duy nhất (FD-397): hàng lỗi sản xuất + phần lỗi khi hoàn đơn. */
    is_defect_shelf: boolean
    /** Cho phép bán từ kệ hàng lỗi. false: lô ở kệ lỗi không bán được. */
    defect_allow_sale: boolean
    created_at: string
    updated_at: string
}

export interface ListWarehousePositionsParams {
    lot_type?: WarehousePositionLotType
    is_active?: boolean
    search?: string
    page?: number
    per_page?: number
}

export interface CreateWarehousePositionRequest {
    code: string
    name?: string
    applicable_lot_types: WarehousePositionLotType[]
    is_pos_shelf?: boolean
}

export interface UpdateWarehousePositionRequest {
    code?: string
    name?: string | null
    applicable_lot_types?: WarehousePositionLotType[]
    is_active?: boolean
    is_return_shelf?: boolean
    is_pos_shelf?: boolean
    is_defect_shelf?: boolean
    defect_allow_sale?: boolean
}

const BASE = '/warehouse-positions'

export const warehousePositionApi = {
    list: (params?: ListWarehousePositionsParams) =>
        api.get<WarehousePosition[]>(BASE, { params }),
    getById: (id: string) => api.get<WarehousePosition>(`${BASE}/${id}`),
    /** Tồn theo mặt hàng của một vị trí — dòng bung trên màn danh sách vị trí.
     *  Cùng quyền `warehouse_positions.read` với chính màn đó. */
    stock: (id: string) =>
        api.get<WarehousePositionStockItem[]>(`${BASE}/${id}/stock`),
    create: (data: CreateWarehousePositionRequest) =>
        api.post<WarehousePosition>(BASE, data),
    update: (id: string, data: UpdateWarehousePositionRequest) =>
        api.patch<WarehousePosition>(`${BASE}/${id}`, data),
    remove: (id: string) => api.delete(`${BASE}/${id}`),
}
